/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Public_View_CreditsInputs */

const en_pricing_public_view_credits = /** @type {(inputs: Pricing_Public_View_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View credits`)
};

const es_pricing_public_view_credits = /** @type {(inputs: Pricing_Public_View_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver creditos`)
};

/**
* | output |
* | --- |
* | "View credits" |
*
* @param {Pricing_Public_View_CreditsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_public_view_credits = /** @type {((inputs?: Pricing_Public_View_CreditsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Public_View_CreditsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_public_view_credits(inputs)
	return es_pricing_public_view_credits(inputs)
});